// AI Generated Test
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { LabelService } from '@monsido/services/label-service/label.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { PageDetailsComponent } from '@client/app/components/pagedetails/details/page-details.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-misspellings-table',
    standalone: false,
    template: `
        <table-container
                [disablePagination]="disablePagination"
                [progress]="progress"
                [collection]="pages"
                (onPageChange)="pageChangeEvent($event)"
                (onPerPageChange)="perPageChangeEvent($event)"
                noResultMessage="{{ 'Good job! No issues were found' | translate }}"
                class="pages-table-wrapper"
        >
            <table-container-top>
                <div class="outer-b merge-r-36 merge-l-36 merge-t-10" *ngIf="isFiltersOpen">
                    <table-filters [(open)]="isFiltersOpen"
                                   (openChange)="isFiltersOpenChange.emit($event)"
                                   [(ngModel)]="filters"
                                   name="filters"
                                   [filters]="availableFilters"
                                   (onChanges)="onFiltersChangeEvent($event)">
                    </table-filters>
                </div>
            </table-container-top>
            <table class="table table-hover table-fixed table-with-labels">
                <thead>
                <tr>
                    <th monTableSort
                        [monSortDirection]="currentSort?.direction"
                        monSortBy="title"
                        [monCurrentlySortedBy]="currentSort?.by"
                        (monOnSorted)="onSortPageChangeEvent($event)">
                        {{ 'Title' | translate }}
                    </th>
                    <th class="col-4 col-lg-4 text-right" translate>Language</th>
                    <th class="col-4 col-lg-4 text-right"
                        monTableSort
                        monSortBy="spelling_errors_confirmed_count"
                        [monSortDirection]="currentSort?.direction"
                        [monCurrentlySortedBy]="currentSort?.by"
                        (monOnSorted)="onSortPageChangeEvent($event)"><span translate>Misspellings</span></th>
                    <th class="col-5 col-lg-5 text-right"
                        monTableSort
                        monSortBy="spelling_errors_potential_count"
                        [monSortDirection]="currentSort?.direction"
                        [monCurrentlySortedBy]="currentSort?.by"
                        (monOnSorted)="onSortPageChangeEvent($event)"><span translate>Potential misspellings</span></th>
                    <th class="col-5 col-lg-5 text-right"
                        monTableSort
                        monSortBy="hits"
                        [monSortDirection]="currentSort?.direction"
                        [monCurrentlySortedBy]="currentSort?.by"
                        (monOnSorted)="onSortPageChangeEvent($event)"
                        *ngIf="viewsColumIsAvailable">
                        <span translate>Views</span>
                        <span *ngIf="hasAccessToStats"
                              class="ml-1"
                              [ngClass]="['QA', 'QUESTION_CIRCLE'] | monIcons"
                              aria-hidden="true"
                              ngbTooltip="{{ 'Total page views over the last 30 days' | translate }}"
                              [triggers]="'focus hover'">
                        </span>
                        <span *ngIf="!hasAccessToStats"
                              class="ml-1"
                              [ngClass]="['QA', 'EXCLAMATION'] | monIcons"
                              aria-hidden="true"
                              ngbTooltip="{{ 'Statistics not activated. Page Views not available.' | translate }}"
                              [triggers]="'focus hover'">
                        </span>
                    </th>
                    <th class="col-sm-8 col-lg-6 text-right">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let page of pages">
                    <td>
                        <div class="text-ellipsis">
                            <url-title
                                    *ngIf="!pageDetailsIsAvailable"
                                    [title]="page.title"
                                    [url]="page.url"
                                    [active]="false">
                            </url-title>
                            <url-title-page-details
                                    *ngIf="pageDetailsIsAvailable"
                                    [target]="'page-details-section-qa'"
                                    [subTarget]="target"
                                    (onClose)="callBackEvent()"
                                    [page]="page"
                                    [title]="page.title"
                                    [url]="page.url"
                                    [active]="false" >
                            </url-title-page-details>
                        </div>
                        <label-table *ngIf="showLabels"
                                         [assignedLabels]="page.labels"
                                         [existingLabels]="labels"
                                         (getLabels)="getLabels()"
                                         (onUpdateLabel)="updateLabels(page)" />
                    </td>
                    <td class="text-v-middle text-right"><language [language]="page.language"></language></td>
                    <td class="text-v-middle text-right">
                        <icon-button
                                [faIcon]="buttonIcon"
                                [number]="page.spelling_errors_confirmed_count"
                                positive="text-confirmed-misspelling"
                                negative="negative"
                                neutral="text-neutral-misspelling"
                                (callback)="openPageDetails(page, 'misspellings')"
                                [changeTextColor]="false">
                        </icon-button>
                    </td>
                    <td class="text-v-middle text-right">
                        <icon-button
                                [faIcon]="buttonIcon"
                                [number]="page.spelling_errors_potential_count"
                                positive="text-potential-misspelling"
                                negative="negative"
                                neutral="text-neutral-misspelling"
                                (callback)="openPageDetails(page, 'potential')"
                                [changeTextColor]="false">
                        </icon-button>
                    </td>
                    <td *ngIf="viewsColumIsAvailable" class="text-v-middle text-right">
                        <visits [title]="page.title" [visits]="page.hits" [totalVisits]="pages.pageHits"></visits>
                    </td>
                    <td class="text-v-middle text-right">
                        <div class="d-flex align-items-center justify-content-end flex-wrap flex-md-nowrap">
                            <table-page-details
                                    *ngIf="page.type === 'html'"
                                    ngbTooltip="{{'Open page details' | translate}}"
                                    [triggers]="'focus hover'"
                                    [target]="'page-details-section-qa'"
                                    [subTarget]="target"
                                    [page]="page"
                                    (callBack)="callBackEvent()">
                            </table-page-details>
                            <table-document-details
                                    *ngIf="page.type !== 'html'"
                                    aria-label="Page details"
                                    ngbTooltip="{{'Open Document details' | translate}}"
                                    [triggers]="'focus hover'"
                                    [target]="'page-details-section-qa'"
                                    [subTarget]="target"
                                    [document]="page"
                                    (callBack)="callBackEvent()">
                            </table-document-details>
                            <mon-extension-visual-link-button [page]="page" [type]="'mspel'" class="ml-1"></mon-extension-visual-link-button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </table-container>
    `,
})
export class PagesMisspellingsTableComponent extends BaseContainerComponentController implements OnInit {
    @Input() disablePagination: boolean = false;
    @Input() pages: any;
    @Input() progress?: any;
    @Input() override currentSort: any;
    @Input() buttonIcon?: string;
    @Input() target?: any;
    @Input() override isFiltersOpen: boolean = false;
    @Input() override page: number = 1;
    @Input() override pageSize: number = 20;

    // eslint-disable-next-line
    @Output('onPageChange') pageChange = new EventEmitter<any>();
    @Output() onPerPageChange = new EventEmitter<any>();
    @Output() onSortPageChange = new EventEmitter<any>();
    @Output() onFiltersChanges = new EventEmitter<any>();
    @Output() callBack = new EventEmitter<any>();
    @Output() isFiltersOpenChange = new EventEmitter<boolean>();

    viewsColumIsAvailable: boolean = false;
    pageDetailsIsAvailable: boolean = false;
    hasAccessToStats: boolean = false;

    constructor (
        private monEventService: MonEventService,
        private activeFeatureService: ActiveFeatureService,
        private labelService: LabelService,
    ) {
        super({ pages: true, labels: true });
    }

    ngOnInit () {
        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.hasAccessToStats = this.activeFeatureService.isFeatureActive('statistics');
        this.pages = this.pages || [];
        this.disablePagination = this.disablePagination || false;
        this.buttonIcon = this.buttonIcon || 'fas fa-circle';
        this.target = this.target || 'misspellings';
    }

    openPageDetails (page: any, subTarget: string) {
        const params = {
            body: PageDetailsComponent,
            size: 'fw',
            classes: 'page-details-app',
            data: {
                page: page,
                target: 'page-details-section-qa',
                subTarget: subTarget,
            },
        };
        const callback = () => {
            if (this.callBack) {
                this.callBackEvent();
            }
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
    }

    pageChangeEvent (page: any) {
        this.pageChange.emit(page);
    }

    perPageChangeEvent (size: any) {
        this.onPerPageChange.emit(size);
    }

    callBackEvent () {
        this.callBack.emit();
    }

    createOrUpdateLabelEvent (label: any) {
        this.labelService.createOrUpdateLabel(label);
    }

    onSortPageChangeEvent (event: any) {
        this.onSortPageChange.emit(event);
    }

    onFiltersChangeEvent (changes: any) {
        this.onFiltersChanges.emit(changes);
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }
}
